var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,0H3l-1,1V23l1,1H21l1-1V1l-1-1Zm-1,22H4V2H20V22Zm-3-10H7v-2h10v2Zm0-5H7v-2h10v2Zm-4,10H7v-2h6v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/1787897133/media/icon-document.c63e97c4edbb8f4fb6e4e7de205d18f2.svg";
export { ForwardRef as ReactComponent };